// Libraries
import React from 'react';

// Supermove
import {Space, Styled} from '@supermove/components';
import {MilestoneModel} from '@supermove/models';
import {colors} from '@supermove/styles';

// App
import Text from '@shared/design/components/Text';

const CampaignContainer = Styled.View`
  flex-direction: column;
`;

const UtmFieldsContainer = Styled.View``;

const UtmDetailsComponent = ({milestone}: {milestone: MilestoneModel}) => {
  const hasAdditionalUtmFields =
    milestone.utmMedium || milestone.utmSource || milestone.utmContent || milestone.utmTerm;

  if (!hasAdditionalUtmFields) {
    return null;
  }

  return (
    <CampaignContainer>
      <UtmFieldsContainer>
        {[
          {label: 'Medium', value: milestone.utmMedium},
          {label: 'Source', value: milestone.utmSource},
          {label: 'Content', value: milestone.utmContent},
          {label: 'Term', value: milestone.utmTerm},
        ].map(({label, value}) =>
          value ? (
            <React.Fragment key={label}>
              <Space height={2} />
              <Text.Body style={{color: colors.gray.secondary}}>
                {label}: {value}
              </Text.Body>
            </React.Fragment>
          ) : null,
        )}
      </UtmFieldsContainer>
    </CampaignContainer>
  );
};

export default UtmDetailsComponent;
